// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"29d6a608","412":"cf90dbf0","596":"52b3c053","619":"c2b36031","923":"ad2a8f97"}[chunkId] + ".css";
};